module.exports = __webpack_public_path__ + "static/media/mutualfund.cf818320.png";